<template>
  <div class="">
    <div>
      <nav
        id="nava-navbar"
        class="font-bold"
        :class="[
          sticky ? 'fixed top-0 w-full z-40 shadow-main opacity-0' : '',
          bgColor,
        ]"
      >
        <div class="gridClass">
          <div class="py-2">
            <div class="flex justify-between items-center">
              <div class="">
                <div class="flex justify-between items-center [&>*]:me-12">
                  <div class="flex justify-center items-center me-6">
                    <div class="flex justify-center items-center text-4xl">
                      <NuxtImg
                        sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                        width="1000"
                        height="1000"
                        class="me-1"
                        :class="sticky ? 'w-10' : 'w-16'"
                        format="webp"
                        quality="100"
                        src="/img/landing/logo.svg"
                        alt="navatel.ir"
                      />
                      <h3 class="text-white mr-2">نواتل</h3>
                    </div>
                  </div>
                </div>
                <div v-if="!sticky" class="text-white text-2xl mr-10 mt-2">
                  نسل نوین ارتباط
                </div>
              </div>
              <!-- <NuxtLink to="/OnlineShopping" class="just-desktop">
                <BaseButton
                  noArrow
                  text="خرید آنلاین"
                  id="onlineShopping_btn"
                  classes="bg-yellow-500 !text-blue-700 h-[50px] !font-bold rounded-lg"
                />
              </NuxtLink> -->
            </div>
          </div>
        </div>
      </nav>
    </div>

    <slot />

    <section class="flex flex-col w-full bg-blue-200">
      <section class="gridClass">
        <div
          class="w-full pt-3 laptop:pt-12 mb-3 flex flex-col laptop:flex-row items-start justify-between"
        >
          <div class="w-full flex text-justify flex-col justify-around">
            <div class="flex justify-between items-center">
              <div class="flex justify-center items-center">
                <!-- <NuxtLink
                  to="/"
                  class="block laptop:flex justify-center items-center text-4xl text-blue-700"
                > -->
                <NuxtImg
                  sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                  width="1000"
                  height="1000"
                  class="me-1 w-16"
                  format="webp"
                  quality="100"
                  src="/img/icon.png"
                  alt="navatel.ir"
                />
                <span class="text-lg laptop:text-2xl font-bold">
                  با
                  <div class="inline-block relative">
                    <div
                      class="absolute left-0 -top-2 rounded-full w-[90%] aspect-square bg-yellow-500"
                    ></div>
                    <span class="relative">نواتل</span>
                  </div>
                  به کسب و کار بهتری تبدیل شوید
                </span>
                <!-- </NuxtLink> -->
              </div>
            </div>

            <div class="just-desktop mt-10 font-bold">
              ما را در شبکه‌های اجتماعی دنبال کنید
            </div>

            <div class="just-desktop">
              <div class="flex justify-start mt-2">
                <NuxtLink
                  to="https://www.aparat.com/Navatel"
                  aria-label="Navatel Aparat"
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    class="mx-1 w-8"
                    format="webp"
                    quality="100"
                    src="/img/aparat.webp"
                    alt="navatel aparat"
                  />
                </NuxtLink>
                <NuxtLink
                  to="https://www.linkedin.com/company/mynavatel/"
                  aria-label="Navatel Linkedin"
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    class="mx-1 w-8"
                    format="webp"
                    quality="100"
                    src="/img/linkdin.webp"
                    alt="navatel linkdin"
                  />
                </NuxtLink>
                <NuxtLink
                  to="https://www.instagram.com/navatel.ir/"
                  aria-label="Navatel Instagram"
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    class="mx-1 w-8"
                    format="webp"
                    quality="100"
                    src="/img/instagram.webp"
                    alt="navatel instagram"
                  />
                </NuxtLink>
              </div>
            </div>
          </div>

          <div
            class="flex-grow ml-0 mr-auto mt-8 laptop:mt-0 laptop:flex laptop:justify-between"
          >
            <div>
              <div class="grid grid-cols-2 gap-3">
                <NuxtLink
                  class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://logo.samandehi.ir/Verify.aspx?id=272681&p=uiwkjyoeuiwkgvkamcsirfth"
                  aria-label="logo.samandehi.ir"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/samandehi.webp"
                    alt="ساماندهی"
                  />
                </NuxtLink>
                <NuxtLink
                  class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://trustseal.enamad.ir/?id=316143&Code=GZS45wVZZYKd4Se99ieH"
                  aria-label="trustseal.enamad.ir"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/enamad.webp"
                    alt="اینماد"
                  />
                </NuxtLink>
                <NuxtLink
                  class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://195.cra.ir/"
                  aria-label="195.cra.ir"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/samane.webp"
                    alt="ویپ"
                  />
                </NuxtLink>
                <NuxtLink
                  class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://tehran.irannsr.org/fa/page/104366-%D9%85%D8%B4%D8%A7%D9%87%D8%AF%D9%87-%D8%A7%D8%B9%D8%B6%D8%A7.html?ctp_id=1086&id=33940"
                  aria-label="tehran.irannsr.org"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/nezam.webp"
                    alt="سازمان نظام صنفی"
                  />
                </NuxtLink>
              </div>
            </div>
          </div>
          <div class="just-mobile w-full">
            <div class="mt-10 font-bold">
              ما را در شبکه‌های اجتماعی دنبال کنید
            </div>

            <div class="float-left">
              <div class="flex justify-start mt-2">
                <NuxtLink
                  to="https://www.aparat.com/Navatel"
                  aria-label="Navatel Aparat"
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    class="mx-1 w-8"
                    format="webp"
                    quality="100"
                    src="/img/aparat.webp"
                    alt="navatel aparat"
                  />
                </NuxtLink>
                <NuxtLink
                  to="https://www.linkedin.com/company/mynavatel/"
                  aria-label="Navatel Linkedin"
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    class="mx-1 w-8"
                    format="webp"
                    quality="100"
                    src="/img/linkdin.webp"
                    alt="navatel linkdin"
                  />
                </NuxtLink>
                <NuxtLink
                  to="https://www.instagram.com/navatel.ir/"
                  aria-label="Navatel Instagram"
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    class="mx-1 w-8"
                    format="webp"
                    quality="100"
                    src="/img/instagram.webp"
                    alt="navatel instagram"
                  />
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="gridClass">
        <div class="flex items-center justify-center w-full">
          <div class="flex-grow bg-blue-700 h-0.5 opacity-30" />
        </div>
      </div>
      <div class="gridClass">
        <div
          class="w-full text-xs font-bold flex items-center justify-start mt-2 mb-4"
        >
          <p>
            تمام حقوق مادی و معنوی متعلق به نواتل، تنها سرویس یکپارچه ابری
            (UCaaS) در ایران می باشد.
          </p>
        </div>
      </div>
      <div class="flex-grow h-2 bg-blue-700" />
    </section>

    <LazyHydrate when-idle>
      <SectionModalMain />
    </LazyHydrate>

    <LazyHydrate when-idle>
      <SectionModalSuccess />
    </LazyHydrate>
  </div>
</template>

<script setup>
const props = defineProps({
  bgColor: {
    type: String,
    default: "bg-blue-700",
  },
});

const sticky = ref(false);

const setSticky = () => {
  sticky.value = true;
  let element = document.getElementById("nava-navbar");
  if (element) {
    element.classList.add("showStickyMenu");
  }
};
const setNotSticky = () => {
  sticky.value = false;
};
onMounted(() => {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 300) {
      setSticky();
    } else {
      setNotSticky();
    }
  });
});
</script>

<style scoped>
.showStickyMenu {
  opacity: 0;
  animation: .6s ease-in 0.3s fadein;
  animation-fill-mode: both;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
